/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><mpx-view @tap="handleMoreClick" class="container-header">{{pageTitle}}<mpx-image src="https://dpubstatic.udache.com/static/dpubimg/jv7ZfM1G_Bf66YjRFpS2U.png" class="arrow" v-if="(!disable)"></mpx-image></mpx-view><es-popup :show="(show)" :closeable="(closeable)" @close="onClose" position="bottom"><es-calendar :value="(innerVal)" :disabled="(disabled)" :type="(checkType)" :title="(title)" :formatter="(formatter)" :color="(color)" :show-confirm="(showConfirm)" :start-text="(startText)" :end-text="(endText)" :confirm-text="(confirmText)" :first-day="(firstDay)" :max-range="(maxRange)" :maxDate="(innerMaxDate)" :minDate="(innerMinDate)" :format="(format)" :allow-same-day="(allowSameDay)" @confirm="onConfirm" @input="onInput"></es-calendar></es-popup></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m35be2d8b"}'>
  .container-header
    display flex
    justify-content center
    align-items center
    // height 36px
    // margin-right 12px
    // background rgba(60, 90, 134, 0.06)
    // border-radius 8px
    // margin-left 12px
    font-size 18px
    font-family PingFangSC-Medium
    color #333333
  .arrow
    width 12px
    height 6px
    margin-left 6.5px
  // .day_text
  //   font-family PingFangSC-Regular
  //   font-size 14px
  //   color #10294D
  //   text-align center
  //   font-weight 400
  //   line-height 36px
  // .day_text_icon
  //   width 12px
  //   height 12px
  //   margin-top 4px
  // .before_day
  //   margin-right auto
  // .after_day
  //   margin-left auto
  // // .week
  // // font-size 11px
  // // font-family Ping Fang SC
  // // font-weight 400
  // // .calendar
  // // display flex
  // // height 100%
  // // flex-wrap nowrap
  // // flex-direction row
  // // .calendar-item
  // // display flex
  // // width 62px
  // // height 44px
  // // flex-shrink 0
  // // flex-direction column
  // // justify-content center
  // // text-align center
  // // box-sizing border-box
  // // .isActived
  // // color #ffffff
  // // border-radius 6px
  // // background #1473FF
  // // .noCheck
  // // color #BBBBBB
  // .more
  //   // position absolute
  //   // left calc(50% - 31px)
  //   // width 62px
  //   // height 44px
  //   display flex
  //   flex-direction row
  //   justify-content center
  //   align-items center
  //   text-align center
  //   // box-shadow -1px 0px 10px rgba(73,84,100,0.16)
  //   font-weight 400
  //   // background #ffffff
  // .icon
  //   width 18px
  //   height 18px
  //   font-size 18px
  //   margin 2px
  //   color #10294D
  // .day_text_icon-left
  //   margin-left 12px
  //   margin-right 7px
  // .day_text_icon-right
  //   margin-left 7px
  //   margin-right 12px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m35be2d8b"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex35be2d8b%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex35be2d8b%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m35be2d8b"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index35be2d8b/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-calendar':getComponent(require("../../../../components/calendar/index.mpx?isComponent&outputPath=components%2Findex2f88bd1e%2Findex")),'es-popup':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/popup/index.mpx?isComponent&outputPath=components%2Findex9216a4d4%2Findex")),'es-icon':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
